module.exports = __webpack_public_path__ + "static/img/halifax1.fca7cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/halifax1.jpg
// module id = 93
// module chunks = 9